//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { AutoComplete, Button, Card, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Space, Typography } from "antd";

import { FC, useEffect, useState } from "react";
import dayjs from "dayjs";
import { buttomArrow, topArrow } from "assets/icons";
import SearchFormInprocess from "../SearchForm";
import { useGetLotTransactionDetail } from "hooks/useOrders";
import TableOrderList from "../TableOrderList";
import SearchLotDetailForm from "../SearchLotDetailForm";

interface DetailOrderProps {
    id: string
}

const DetailOrder: FC<DetailOrderProps> = ({id}) => {
    const [showContent, setShowContent] = useState(true);
    const [startDate, setStartDate] = useState<any>('');
    const [endDate, setEndDate] = useState<any>('');
    const [wording, setWording] = useState<string>('');
    const [provinceId, setProvinceId] = useState<number>(0);
    const [dcId, setDcId] = useState<string>('');
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);

    // const [startParams, setStartParams] = useState<any>('');
    // const [endParams, setEndParams] = useState<any>('');

    const { data, isLoading, refetch } = useGetLotTransactionDetail({
        lot_no: id,
        search: wording?.trim(),
        // date_start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : '' ,
        // date_end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : '' ,
        status_list: ["wait_dc_ship"],
        offset: offset,
        limit: limit,
        province_id: provinceId,
        dc_id: dcId, 
        sort_by: "desc",
      });
    
    const toggleContent = () => {
      setShowContent(!showContent);
    };
    
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
      // console.log(values)
      setProvinceId(values.province_id);
      setDcId(values.dc_id);
      // setStartDate(startParams)
      // setEndDate(endParams)
      setWording(values.search)
    };



  const layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    
  return (
    <Card bordered={false} className="criclebox h-full tabs-mobile">
      <HeaderTabs>
        <LeftWrapper>
          <Typography.Text
            style={{
              marginTop: 10,
              marginLeft: 10,
              fontWeight: 400,
              fontSize: 14,
            }}
          >
           Lot No. {id}
          </Typography.Text>
        </LeftWrapper>
      </HeaderTabs>
     <HeaderTabs>
        <LeftWrapper>
          <Typography.Text
            style={{
              marginTop: 10,
              marginLeft: 10,
              fontWeight: 400,
              fontSize: 14,
              color: "#417B97",
            }}
          >
           ค้นหา
          </Typography.Text>
        </LeftWrapper>
        <RightIconWrapper>
          <IconWrapper onClick={toggleContent}>
            <SpanIcon>{ showContent ?  buttomArrow : topArrow}</SpanIcon>
          </IconWrapper>
        </RightIconWrapper>
      </HeaderTabs>
      {showContent ? 
      <>
      <Form
      {...layout}
      form={form} 
      onFinish={onFinish}
      >

      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        <SearchLotDetailForm form={form}/>
        <div style={{ flex: '1 1 30%', display: 'flex', justifyContent: 'flex-end' }}> 
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <div style={{ padding: '8px' }}>
              <Button  htmlType="submit" type="primary" style={{ marginRight: '8px' }}>ค้นหา</Button>
            </div>   
          </div>   
        </div>
      </div>
      </Form>
      </> : null}
      <CardWrapperTable>
        <TableOrderList data={data} id={id} offset={offset} limit={limit} setOffset={setOffset} setLimit={setLimit}/>
      </CardWrapperTable>
   </Card>
  );
};

export default DetailOrder;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 15px;
`;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
